const firebaseConfig = {
  apiKey: "AIzaSyCaRvfFqJrRPM4MLSqYpNN8V_sedWZmjwI",
  authDomain: "maas.mobiry.jp",
  projectId: "mobiry",
  databaseURL: "https://mobiry.firebaseio.com",
  storageBucket: "mobiry.appspot.com",
};

export default firebaseConfig;
